import gql from 'graphql-tag';

export const weddingDatePreferencesQueryInOnboarding = gql`
  query wwsOnboardingWeddingDatePreferences {
    weddingDatePreferences {
      datePreference
      hideDate
      season
      year
      weddingDate
      weddingDateFormat
      weddingDateRangeStart
      weddingDateRangeEnd
      hideCountdown
    }
  }
`;

export const updateWeddingDatePreferencesMutation = gql`
  mutation wwsOnboardingUpdateDatePrefMutation($weddingDatePrefAttrs: UpdateWeddingDatePreferencesArgs!) {
    updateWeddingDatePreferences(args: $weddingDatePrefAttrs) {
      datePreference
      year
      season
      hideDate
      weddingDate
      weddingDateFormat
      weddingDateRangeStart
      weddingDateRangeEnd
      hideCountdown
    }
  }
`;

export const updateWeddingDatePreferencesVariantMutation = gql`
  mutation updateDatePrefMutation($weddingDatePrefAttrs: UpdateWeddingDatePreferencesArgs!) {
    updateWeddingDatePreferences(args: $weddingDatePrefAttrs) {
      datePreference
      year
      season
      hideDate
      weddingDate
      weddingDateFormat
      weddingDateRangeStart
      weddingDateRangeEnd
      hideCountdown
      __typename
    }
  }
`;
